import { FlaskConical } from 'lucide-react'
import { useDemoMode } from '@/src/contexts/DemoModeContext'

/**
 * Thin banner shown while Demo Mode is ON so nobody mistakes a demo
 * environment for real verification/payment behaviour.
 */
export function DemoModeBanner() {
  const { demoMode } = useDemoMode()
  if (!demoMode) return null

  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 bg-amber-500 px-4 py-1.5 text-sm font-medium text-white"
    >
      <FlaskConical className="h-4 w-4" aria-hidden="true" />
      DEMO MODE: ข้ามการยืนยัน OTP / KYC และการตรวจสอบการชำระเงิน
    </div>
  )
}
